export default __webpack_public_path__ + "static/vortexa-thumbnail-2a7594d6f3acc9d6352a904c49b572dd.webp";